import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router,NavigationStart } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { LogoutModalComponent } from 'src/app/component/logout-modal/logout-modal.component';
import { environment } from '../../../../src/environments/env';

@Component({
  selector: 'app-authcheck',
  templateUrl: './authcheck.component.html',
  styleUrl: './authcheck.component.scss'
})
export class AuthcheckComponent implements OnInit {
  public logOutDialogConfig: any = {};
  public simpleDialog!: MatDialogRef<LogoutModalComponent>;
  public isGlobalbar: boolean = false;
  constructor(private router: Router, private _auth: AuthService,private dialogModel: MatDialog) { 
  //   this.router.events.subscribe((event) => {
  //   if (event instanceof NavigationStart) {
  //     if (event.navigationTrigger === 'popstate' && event.url.includes('/authcheck')) {
  //       // The user used the back/forward button to hit authcheck
  //       this.router.navigate(['/prelogin'], { replaceUrl: true });
  //     }
  //   }
  // }); 
}

  ngOnInit(): void {

    this.isGlobalbar = false;

    // this.logOutDialogConfig = {
    //   type: 'logout',
    //   forComponent: 'logout',
    //   value: 'You have loged out please login again',
    //   caseScenario: '1'
    // }

    const currentNavigation = this.router.getCurrentNavigation();
    const isInternalNavigation = currentNavigation?.extras?.state?.['incomingFromApp'] 
      || history.state?.['incomingFromApp'];

    if (isInternalNavigation) {

    this._auth.currentMessage.subscribe((message: any) => {
      // if(localStorage.getItem('SPP')==='true'){
      //   localStorage.removItem('SPP');
      //   }
      if (message === 'default message') {

         if(sessionStorage.getItem('router') === '/prelogin') {
          this.router.navigate(['admin', 'refresh'], { skipLocationChange: true }).then(() => {
              this.router.navigate(['prelogin']);
            });
          }
       
        //window.open(environment.BASE_URL+"/ptp/security/ssoBackendRedirect?entryPoint="+environment.APP_URL+"/#/dashboard", '_self');
        //HCL url
        //window.open(environment.IES_URL+"/auth?service=SocialAuthentication&provider=Microsoft&goto=https://pearson-backend.career-shaper.com/ptp/security/ssoBackendRedirect?entryPoint=https://ptp-pearson.career-shaper.com/#/dashboard", '_self');
        //Pearson Url
        
        window.open(environment.IES_URL+"/auth?service=SocialAuthentication&provider=Microsoft&branding=mct&goto=" + environment.BASE_URL + "/ptp/security/ssoBackendRedirect?entryPoint=" + environment.APP_URL + "/#/dashboard&gotoOnFail=" + environment.APP_URL + "/error", '_self');
        localStorage.removeItem('prelogin');
        //sessionStorage.removeItem('link');
        //window.open("https://pearson-backend.career-shaper.com/ptp/security/ssoBackendRedirect?entryPoint= http://localhost:4200/#/dashboard", '_self');
      } 

      
      // else if(message === 'logout'){
      //   this.simpleDialog = this.dialogModel.open(LogoutModalComponent, { data: this.logOutDialogConfig,  disableClose: true });
      // } 
      else {
         if(sessionStorage.getItem('router') === '/admin/dashboard') {
          this.router.navigate(['admin', 'refresh'], { skipLocationChange: true }).then(() => {
              this.router.navigate(['admin', 'dashboard']);
            });
          }
         
        console.log('message'+message);
        if(message.role == 'ADMIN'){
          this.router.navigate(['/admin/dashboard']);
        } else {
          if(sessionStorage.getItem('privacy') === 'true' && sessionStorage.getItem('cookie')==='true'){
            //this.router.navigate(['/dashboard']);
            //this.isGlobalbar = true;
          }
        }
      }
    });
  }
  {
      // Scenario 2: No state found. User hit the "Back" button from Microsoft.
      // Redirect them safely back to prelogin and wipe this route out of history.
      this.router.navigate(['/prelogin'], { replaceUrl: true });
    }
  }

  // @HostListener('window:popstate', ['$event'])
  // onBrowserBack(event: Event) {
  //   // 1. Prevent the default browser back history action
  //   event.preventDefault();

  //   // 2. Force redirect to your specific route
  //   // Using replaceUrl: true prevents the user from getting stuck in a loop
  //   this.router.navigate(['/prelogin'], { replaceUrl: true });
  // }

}
